var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.treeList),function(item){return _c('cItem',{key:item.Id,attrs:{"pitem":item,"readonly":""}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }